import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {

    private messageSource = new BehaviorSubject('blank');
    currentMessage = this.messageSource.asObservable();
    constructor() { }
    changeMessage(message: any) {
    this.messageSource.next(message)
  }

}